var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "ui-field" }, [
    !_vm.multiValueMode
      ? _c("div", { staticClass: "ui-select-field ui-outline-field" }, [
          _c("div", { staticClass: "ui-outline-field-wrapper" }, [
            _c(
              "select",
              {
                attrs: {
                  id: _vm.id,
                  name: _vm.name,
                  required: !!_vm.required,
                  disabled: _vm.disabled,
                },
                domProps: { value: _vm.value },
                on: { input: _vm.onInput },
              },
              [
                _vm.blankString
                  ? _c(
                      "option",
                      { attrs: { disabled: "", selected: "", value: "" } },
                      [_vm._v(_vm._s(_vm.blankString))]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm._l(_vm.options, function (option, i) {
                  return _c(
                    "option",
                    {
                      attrs: { disabled: option.value == "-" },
                      domProps: { value: option.value },
                    },
                    [_vm._v(_vm._s(option.name))]
                  )
                }),
              ],
              2
            ),
            _vm._v(" "),
            _c("div", { staticClass: "ui-outline" }, [
              _c("div", { staticClass: "ui-outline-left" }),
              _vm._v(" "),
              _c("div", { staticClass: "ui-outline-middle" }, [
                _c("label", { attrs: { for: _vm.id } }, [
                  _vm._v(
                    "\n            " + _vm._s(_vm.label) + "\n            "
                  ),
                  _vm.required
                    ? _c("span", { staticClass: "ui-field-required-marker" })
                    : _vm._e(),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "ui-outline-right" }),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "ui-select-field-caret-icon" }, [
              _c(
                "svg",
                {
                  attrs: {
                    xmlns: "http://www.w3.org/2000/svg",
                    viewBox: "0 0 10 10",
                  },
                },
                [
                  _c("path", {
                    attrs: { d: "M0 3h10L5 8", "fill-rule": "nonzero" },
                  }),
                ]
              ),
            ]),
          ]),
        ])
      : _c("div", [
          _c(
            "select",
            {
              staticClass: "multi",
              attrs: {
                id: _vm.name,
                name: _vm.name,
                required: !!_vm.required,
                disabled: _vm.disabled,
                multiple: "",
                size: _vm.options.length - 1,
              },
              on: { input: _vm.onMultiInput },
            },
            _vm._l(_vm.options, function (option, i) {
              return option.value !== ""
                ? _c(
                    "option",
                    {
                      domProps: {
                        value: option.value,
                        selected: _vm.value.includes(option.value),
                      },
                    },
                    [_vm._v(_vm._s(option.name))]
                  )
                : _vm._e()
            }),
            0
          ),
        ]),
    _vm._v(" "),
    _vm.multi
      ? _c("div", { staticClass: "multi-select-toggle" }, [
          !_vm.multiValueMode
            ? _c("div", [
                _c(
                  "a",
                  {
                    on: {
                      click: function ($event) {
                        $event.preventDefault()
                        return _vm.switchToMultiValue.apply(null, arguments)
                      },
                    },
                  },
                  [_vm._v("Multi Select")]
                ),
              ])
            : _c("div", [
                _c(
                  "a",
                  {
                    on: {
                      click: function ($event) {
                        $event.preventDefault()
                        return _vm.switchToSingleValue.apply(null, arguments)
                      },
                    },
                  },
                  [_vm._v("Single Select")]
                ),
              ]),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }